<template>
  <UikitFormInput
    :model-value="price"
    :type="isFocused ? 'number' : 'text'"
    :name="name"
    :size="size"
    :text-left="textLeft"
    inputmode="numeric"
    pattern="[0-9]*"
    :background="!isDesktop ? 'grey-4' : undefined"
    @focus="isFocused = true"
    @blur="handleBlur"
    @update:model-value="handleUpdate"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue?: number
  name: string
  type?: 'text' | 'password' | 'number'
  textLeft?: string
  size?: 'm' | 'l'
  min?: number
  max?: number
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: number): void,
  (e: 'blur'): void,
}>();

const { isDesktop } = useUiBreakpoints();

const isFocused = ref(false);

const price = computed(() => {
  const value = props.modelValue ?? 0;

  if (isFocused.value) return value;

  const options = {
    maximumFractionDigits: 0,
    currency: 'RUB',
    style: 'currency',
    currencyDisplay: 'symbol',
  };

  return value.toLocaleString('ru-RU', options);
});

function handleUpdate(value?: string) {
  const number = !Number(value) ? 0 : Number(value ?? '0');

  emits('update:modelValue', number);
}

function handleBlur() {
  isFocused.value = false;
  emits('blur');
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

</style>
